// extracted by mini-css-extract-plugin
export default {"container":"ModelList_container__IntFQ","heading":"ModelList_heading__4neFu","cards":"ModelList_cards__o6xVu"};